import { render, staticRenderFns } from "./adminMainLayout.vue?vue&type=template&id=107bb010"
import script from "./adminMainLayout.vue?vue&type=script&lang=js"
export * from "./adminMainLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports